import { render } from "./UserDetail.vue?vue&type=template&id=906963e6&scoped=true&ts=true"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"

import "./UserDetail.vue?vue&type=style&index=0&id=906963e6&lang=sass&scoped=true"
import "./UserDetail.vue?vue&type=style&index=1&id=906963e6&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906963e6"]])

export default __exports__